// src/components/Playlists.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Grid,
  Image,
  Text,
  VStack,
  useColorMode,
  Center,
  Icon,
} from "@chakra-ui/react";
import { FaMusic } from "react-icons/fa";

function Playlists({ accessToken, refreshTrigger }) {
  const [playlists, setPlaylists] = useState([]);
  const { colorMode } = useColorMode();

  useEffect(() => {
    if (!accessToken) return;

    axios
      .get("https://api.spotify.com/v1/me/playlists", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        setPlaylists(res.data.items);
      })
      .catch((err) => {
        console.error("Failed to fetch playlists", err);
      });
  }, [accessToken, refreshTrigger]);

  return (
    <VStack spacing={6} w="100%">
      <Text
        fontSize="xl"
        fontWeight="bold"
        color={colorMode === "light" ? "gray.800" : "white"}
        textAlign="center"
      >
        Your Playlists
      </Text>
      <Grid
        templateColumns="repeat(auto-fill, minmax(150px, 1fr))"
        gap={6}
        w="100%"
        justifyItems="center"
      >
        {playlists.map((playlist) => (
          <Box
            key={playlist.id}
            as="a"
            href={playlist.external_urls.spotify}
            target="_blank"
            rel="noopener noreferrer"
            w="150px"
            _hover={{
              transform: "scale(1.05)",
              transition: "transform 0.2s",
            }}
          >
            <VStack spacing={2} align="stretch">
              <Box
                position="relative"
                w="150px"
                h="150px"
                borderRadius="md"
                overflow="hidden"
                boxShadow="md"
              >
                {playlist?.images?.length > 0 && playlist.images[0]?.url ? (
                  <Image
                    src={playlist.images[0].url}
                    alt={playlist.name || 'Playlist'}
                    w="100%"
                    h="100%"
                    objectFit="cover"
                  />
                ) : (
                  <Center
                    w="100%"
                    h="100%"
                    bg={colorMode === "light" ? "gray.100" : "gray.700"}
                  >
                    <Icon
                      as={FaMusic}
                      w={8}
                      h={8}
                      color={colorMode === "light" ? "gray.400" : "gray.500"}
                    />
                  </Center>
                )}
              </Box>
              <Text
                fontWeight="medium"
                color={colorMode === "light" ? "gray.700" : "gray.200"}
                noOfLines={2}
                textAlign="center"
              >
                {playlist?.name || 'Untitled Playlist'}
              </Text>
              <Text
                fontSize="sm"
                color={colorMode === "light" ? "gray.500" : "gray.400"}
                textAlign="center"
              >
                {playlist?.tracks?.total || 0} tracks
              </Text>
            </VStack>
          </Box>
        ))}
      </Grid>
    </VStack>
  );
}

export default Playlists;
